import React from "react";
import {inject, observer} from "mobx-react";
//local
import {Tag} from "components/Tag";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import {color} from "constants/color.consts";

const JoiningOrg = inject("store")(
  observer(({store: {auth}, organizatioName, isPending}) => {
    return (
      <div className="joining-organization__header">
        <div className="fz-16 mid-gray">{organizatioName}</div>
        {isPending ? (
          <Tag
            text="APPLICATION_PENDING"
            needTranslation
            color={color.orange}
            uppercase
            addClass="ml-2 mr-4"
          />
        ) : (
          <div className="mr-4" />
        )}
        <ButtonTransparent
          name="SIGN_OUT"
          color="red"
          small
          loading={auth.logoutLoading}
          onClick={() => auth.logout()}
        />
      </div>
    );
  })
);

export default JoiningOrg;
